import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const KickoffStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Kickoff Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
